import { render } from "./index.vue?vue&type=template&id=fd2c3eac"
import script from "./fifth.js?vue&type=script&lang=js&external"
export * from "./fifth.js?vue&type=script&lang=js&external"

import "./fifth.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__